"use client";

import { useRef, useState } from "react";
import styles from "./VideoBlock.module.css";
import classNames from "classnames/bind";
import { PlayButton } from "../PlayButton/PlayButton";

export interface VideoBlockProps {
  className?: string;
  video?: string;
  videoPoster?: string;
  fullWidth?: boolean;
}

const cx = classNames.bind(styles);

export default function VideoBlock({
  className,
  video,
  videoPoster,
  fullWidth = false,
}: VideoBlockProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  if (!video) {
    return;
  }

  const handlePlay = async () => {
    if (videoRef.current) {
      await videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div
      className={cx("video-container", { "full-width": fullWidth }, className)}
    >
      {!isPlaying && (
        <div className={cx("play-button")}>
          <PlayButton onClick={handlePlay} />
        </div>
      )}
      <video
        ref={videoRef}
        className={cx("video", { "full-width": fullWidth })}
        src={video}
        poster={videoPoster}
        muted
        loop
        playsInline
        controls={isPlaying}
        onClick={() => {
          if (!isPlaying) {
            handlePlay();
          }
        }}
      ></video>
    </div>
  );
}
